import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import Helmet from 'react-helmet';

import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';
import { addTrailingSlash } from '../../utils/uriUtils';

function SharedHeadLinkTagsComponent({ metadata, localeOrigin, additionalLinks }) {
    const linkTagsArray = [
        {
            rel: 'dns-prefetch',
            href: process.env.NODE_CDN_HOST,
        },
        ...additionalLinks,
    ];

    if (!metadata.disableIndexing) {
        const { canonical, prev, next } = metadata;

        linkTagsArray.push({
            rel: 'canonical',
            href: addTrailingSlash(`${localeOrigin}/${canonical}`),
        });

        if (prev) {
            linkTagsArray.push({
                rel: 'prev',
                href: addTrailingSlash(`${localeOrigin}/${prev}`),
            });
        }

        if (next) {
            linkTagsArray.push({
                rel: 'next',
                href: addTrailingSlash(`${localeOrigin}/${next}`),
            });
        }
    }

    return <Helmet link={linkTagsArray} />;
}

SharedHeadLinkTagsComponent.defaultProps = {
    additionalLinks: [],
};

SharedHeadLinkTagsComponent.propTypes = {
    metadata: PropTypes.object.isRequired,
    localeOrigin: PropTypes.string.isRequired,
    additionalLinks: PropTypes.array,
};

function SharedHeadLinkTagsServerVarsContextComponent(props) {
    return (
        <ServerVarsContextConsumer>
            {({ localeOrigin }) => (
                <SharedHeadLinkTagsComponent {...props} localeOrigin={localeOrigin} />
            )}
        </ServerVarsContextConsumer>
    );
}

export const SharedHeadLinkTags = createFragmentContainer(
    SharedHeadLinkTagsServerVarsContextComponent,
    {
        metadata: graphql`
            fragment SharedHeadLinkTags_metadata on MetaData {
                canonical
                disableIndexing
                next
                prev
            }
        `,
    }
);
